export default __webpack_public_path__ + "static/media/android.f050baa8.svg";